import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function BlogCard({BLOGS = []}) {
  const navigate = useNavigate()
  return (
       <section className="max-w-7xl mx-auto px-4 py-16">
        <div className="flex items-end justify-between mb-8">
          <div>
            <p className="text-sm font-bold text-[#f97316] uppercase tracking-wider mb-1">From the Blog</p>
            <h2 className="font-serif text-4xl text-gray-900">Stories & <span className="text-[#f97316]">Recipes</span></h2>
          </div>
          <button onClick={() =>{
            navigate("/blog")
          }} className="text-sm font-bold text-[#f97316] hover:underline">All Articles →</button>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {BLOGS.slice(0,3).map((b,i) => (
            <button key={b.id} onClick={() => {}} className={`text-left bg-white rounded-3xl overflow-hidden border border-gray-100 card-hover group afu d${i+1}`}>
              <div className="img-zoom overflow-hidden">
                <img src={b.img} alt={b.title} className="w-full h-48 object-cover"/>
              </div>
              <div className="p-5">
                <span className="text-xs font-bold text-[#f97316] bg-orange-50 px-2.5 py-1 rounded-full">{b.cat}</span>
                <h3 className="font-bold text-gray-900 mt-3 mb-2 leading-snug group-hover:text-[#f97316] transition-colors">{b.title}</h3>
                <p className="text-xs text-gray-400 lc2 leading-relaxed mb-3">{b.excerpt}</p>
                <div className="flex items-center gap-2 text-xs text-gray-400">
                  <span>✍️ {b.author}</span><span>·</span><span>⏱ {b.read}</span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </section>
  )
}
